import { Expose } from 'class-transformer';
import { Model } from '@shared/models/model';

export class OrderFulfillment extends Model {

  @Expose() id: number;
  @Expose() title: string;
  @Expose() total: number;
  @Expose() completed: number;
  @Expose() pending: number;
  @Expose() month: number;
  @Expose() year: number;
}
